import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Card } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function FieldsTab() {
  const { meta, refreshMeta } = useApp();
  const [labels, setLabels] = useState({});
  const [cats, setCats] = useState("");
  const [team, setTeam] = useState("");
  useEffect(() => {
    if (!meta) return;
    setLabels(meta.labels);
    setCats(meta.categories.join("\n"));
    setTeam((meta.team || []).join("\n"));
  }, [meta]);
  if (!meta) return null;
  const save = async () => {
    try {
      await api.put("/schema", { labels, categories: cats.split("\n"), team: team.split("\n") });
      toast.success("Saved");
      refreshMeta();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-6" data-testid="fields-tab">
      <Card title="Field names" subtitle="Rename how each field appears in the app, exports and the master Google Sheet header.">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {meta.fields.map((f) => (
            <div key={f.key} className="space-y-1">
              <div className="text-xs font-medium text-slate-400">{f.key}</div>
              <Input data-testid={`label-input-${f.key}`} className="h-10 rounded-lg" value={labels[f.key] || ""} onChange={(e) => setLabels({ ...labels, [f.key]: e.target.value })} />
            </div>
          ))}
        </div>
      </Card>
      <div className="grid gap-6 md:grid-cols-2">
        <Card title="Complaint categories" subtitle="One per line">
          <Textarea data-testid="categories-textarea" rows={12} className="rounded-xl" value={cats} onChange={(e) => setCats(e.target.value)} />
        </Card>
        <Card title="Team members (Assigned to)" subtitle="One per line. Shown in the Assigned to list.">
          <Textarea data-testid="team-textarea" rows={12} className="rounded-xl" value={team} onChange={(e) => setTeam(e.target.value)} />
        </Card>
      </div>
      <Button className="h-11 rounded-xl px-6" onClick={save} data-testid="fields-save-button">Save fields & lists</Button>
    </div>
  );
}
